import * as v from 'valibot'

// Don't worry, my beautiful R.E.P.O. devs, wipe your tears, this "cheating" is for group fun :) :D
const repoKeyString = `Why would you want to cheat?... :o It's no fun. :') :'D`
const ivLength = 16
const encoder = new TextEncoder()

export const repoSaveSchema = v.looseObject({
    teamName: v.looseObject({
        value: v.string()
    }),
    dateAndTime: v.looseObject({
        value: v.string()
    }),
    playerNames: v.looseObject({
        value: v.record(v.string(), v.string())
    }),
    dictionaryOfDictionaries: v.looseObject({
        value: v.intersect([
            v.looseObject({
                runStats: v.looseObject({
                    level: v.number(),
                    totalHaul: v.number(),
                    currency: v.number(),
                    'save level': v.number()
                }),
                itemsPurchasedTotal: v.record(v.string(), v.number()),
                // Items in truck
                itemsPurchased: v.record(v.string(), v.number()),
                itemsUpgradesPurchased: v.record(v.string(), v.number()),
                playerHealth: v.record(v.string(), v.number())
            }),
            v.record(v.string(), v.record(v.string(), v.number()))
        ])
    })
})
export type RepoSave = v.InferOutput<typeof repoSaveSchema>

// The player upgrades listed in the save can differ from the item name
// For example, "Stamina" vs "Energy"
// The full item name has to be included here because they have different prefixes for the shortnames
export const knownPlayerUpgradeToItemMapping: {[playerUpgradeName: string]: string} = {
    'Health': 'Item Upgrade Player Health',
    'Stamina': 'Item Upgrade Player Energy',
    'ExtraJump': 'Item Upgrade Player Extra Jump',
    'Launch': 'Item Upgrade Player Tumble Launch',
    'TumbleClimb': 'Item Upgrade Player Tumble Climb',
    'DeathHeadBattery': 'Item Upgrade Death Head Battery',
    'MapPlayerCount': 'Item Upgrade Map Player Count',
    'Speed': 'Item Upgrade Player Sprint Speed',
    'Strength': 'Item Upgrade Player Grab Strength',
    'Range': 'Item Upgrade Player Grab Range',
    'CrouchRest': 'Item Upgrade Player Crouch Rest',
    'TumbleWings': 'Item Upgrade Player Tumble Wings'
}
export const healthUpgradeFullName = 'playerUpgradeHealth'

export const saveLevels = {
    level: 0,
    shop: 1,
    truck: 2
}

let cachedRepoKey: CryptoKey | undefined
async function getRepoKey() {
    if(cachedRepoKey !== undefined) return cachedRepoKey
    cachedRepoKey = await crypto.subtle.importKey('raw', encoder.encode(repoKeyString), 'PBKDF2', false, ['deriveKey'])
    return cachedRepoKey
}

async function deriveRepoKey(iv: BufferSource, usage: KeyUsage) {
    return await crypto.subtle.deriveKey(
        {
            name: 'PBKDF2',
            hash: 'SHA-1',
            salt: iv,
            iterations: 100
        },
        await getRepoKey(),
        {
            name: 'AES-CBC',
            length: 128
        },
        false, [usage]
    )
}

export async function decodeREPOSave(data: Uint8Array): Promise<RepoSave> {
    const iv = data.slice(0, ivLength)
    const key = await deriveRepoKey(iv, 'decrypt')
    const decryptedData = await crypto.subtle.decrypt({name: 'AES-CBC', iv}, key, data.slice(ivLength))
    const decoded = (new TextDecoder()).decode(decryptedData)
    return v.parse(repoSaveSchema, JSON.parse(decoded))
}

export async function encodeREPOSave(save: RepoSave) {
    const data = encoder.encode(JSON.stringify(save, (_, value) => {
        // super annoying: the save files aren't *technically* JSON
        // the key ordering matters, the "__type" key must be first or REPO will flag it as a corrupted save
        if(value instanceof Object && !Array.isArray(value)) {
            return [
                ...Object.entries(value).filter(([k, _]) => k === '__type'),
                ...Object.entries(value).filter(([k, _]) => k !== '__type')
            ].reduce((prev, [k, v]) => {
                prev[k] = v
                return prev
            }, {} as any)
        } else {
            return value
        }
    }))
    const iv = crypto.getRandomValues(new Uint8Array(ivLength))
    const key = await deriveRepoKey(iv, 'encrypt')
    const encryptedData = await crypto.subtle.encrypt({name: 'AES-CBC', iv}, key, data)
    const dataAndIV = new Uint8Array(iv.byteLength + encryptedData.byteLength)
    dataAndIV.set(iv)
    dataAndIV.set(new Uint8Array(encryptedData), iv.length)
    return dataAndIV
}